import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { orderDocTypes } from '../../../../config/documents';

class DocumentField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filename: '',
    };
  }

  componentDidMount() {
    try {
      const filename = this.props.doc.file.preview;

      this.setState({ filename });
    } catch (e) {
      console.error('DocumentField, failed to get signed URL: ', e);
    }
  }

  handleTypeChange = (e) => this.props.onTypeChange(e.target.value);
  handleCustomValueChange = (e) =>
    this.props.onCustomValueChange(e.target.value);
  handleRemove = () => this.props.onRemove();

  renderPreview() {
    const { doc } = this.props;

    if (doc.file.type.includes('image')) {
      return (
        <img
          src={this.state.filename}
          alt={doc.file.name}
          className="w-auto"
          style={{ maxHeight: '200px' }}
        />
      );
    }

    let fileIconClass;

    if (doc.file.type.endsWith('doc') || doc.file.type.endsWith('docx')) {
      fileIconClass = 'fa-file-word-o';
    } else if (
      doc.file.type.endsWith('xls') ||
      doc.file.type.endsWith('xlsx')
    ) {
      fileIconClass = 'fa-file-excel-o';
    } else if (doc.file.type.endsWith('pdf')) {
      fileIconClass = 'fa-file-pdf-o';
    } else {
      fileIconClass = 'fa-cloud-download';
    }
    const className = classnames({
      fa: true,
      'fa-4x': true,
      [fileIconClass]: true,
    });

    return (
      <a href={this.state.filename} target="_blank" rel="noreferrer">
        <i className={className} />
      </a>
    );
  }

  render() {
    const { doc, t } = this.props;

    const className = classnames({
      'form-select': true,
      'mr-2': true,
      'mb-4': doc.key === 'custom',
      error: doc.error,
    });
    return (
      <div className="flex flex-wrap items-center content-center shadow rounded bg-white mb-4 p-4">
        <div className="image-wrapper w-1/2">
          <figure className="md:mr-4 mb-2 mr-4 py-1 flex justify-center">
            {this.renderPreview()}
          </figure>
        </div>
        <div className="md:w-1/3">
          <div className="flex items-center">
            <div className="document-field-wrapper">
              <select
                className={className}
                value={doc.type}
                onChange={this.handleTypeChange}
              >
                <option key="empty-type" value="">
                  {t('SELECT_TYPE')}
                </option>
                {orderDocTypes.map((docType) => (
                  <option key={docType.value} value={docType.value}>
                    {t(docType.localizationSlug)}
                  </option>
                ))}
              </select>
              {doc.type === 'custom' && (
                <input
                  type="text"
                  placeholder={t('ENTER_DOCUMENT_TITLE')}
                  className="form-field w-full"
                  onChange={this.handleCustomValueChange}
                />
              )}
            </div>
            <button
              className="secondary-action button"
              onClick={this.handleRemove}
            >
              <i className="fa fa-remove" />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(DocumentField);

DocumentField.propTypes = {
  doc: PropTypes.shape({
    key: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.string.isRequired,
  }),
  onCustomValueChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
